/**
 * ProviderLegend — informational chip strip for the admin calendar.
 *
 * Renders into the PooCalendar `toolbarSlot` (the right-aligned band
 * above the grid). One chip per visible provider showing:
 *
 *   ●  <business name>
 *
 * where the dot is the same hash-derived color the calendar paints on
 * that provider's event pills (via useAdminEventStyle.js).
 *
 * Q7 default: informational only — NO click handlers / no
 * filter-on-click. That can land in E.4-FUTURE if useful.
 */

import { providerColor } from "./useAdminEventStyle";

export default function ProviderLegend({ providers, testidPrefix = "admin-calendar" }) {
  if (!providers || providers.length === 0) return null;
  return (
    <div
      className="flex flex-wrap items-center gap-2"
      role="list"
      aria-label="Provider color legend"
      data-testid={`${testidPrefix}-legend`}
    >
      {providers.map((p) => {
        const color = providerColor(p.id);
        return (
          <div
            key={p.id}
            role="listitem"
            data-testid={`${testidPrefix}-legend-chip-${p.id}`}
            className="flex items-center gap-1.5 rounded-full border border-pp-border bg-pp-surface px-2 py-1 text-xs"
          >
            <span
              aria-hidden="true"
              data-testid={`${testidPrefix}-legend-dot-${p.id}`}
              className="h-2.5 w-2.5 rounded-full"
              style={{ background: color }}
            />
            <span className="text-pp-text">{p.business_name || p.id}</span>
          </div>
        );
      })}
    </div>
  );
}
